module.exports = __webpack_public_path__ + "img/kontakt-porownywarka.5edf60db.png";